module.exports = __webpack_public_path__ + "static/media/flag-gu.78787532.webp";